/**
 * Amplify v6 configuration for the AvatarFactory SPA.
 *
 * We talk DIRECTLY to the Cognito User Pool (no Hosted UI). For email/
 * password Amplify drives USER_SRP_AUTH and shows our own forms. For
 * social sign-in Amplify redirects through the Cognito OAuth2
 * `/authorize` endpoint to Google / Apple / Facebook and returns to our
 * own `/oauth/callback` route - the user never sees Cognito's Hosted UI.
 *
 * The SPA App Client MUST be configured WITHOUT a client secret. See
 * docs/auth.md for the Cognito setup checklist.
 */
import { Amplify } from 'aws-amplify';

import { env } from './env';

const REDIRECT_SIGN_IN = [env.VITE_OAUTH_REDIRECT_SIGN_IN] as const;
const REDIRECT_SIGN_OUT = [env.VITE_OAUTH_REDIRECT_SIGN_OUT] as const;

export function configureAmplify(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: env.VITE_COGNITO_USER_POOL_CLIENT_ID,
        loginWith: {
          email: true,
          oauth: {
            domain: env.VITE_COGNITO_DOMAIN,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [...REDIRECT_SIGN_IN],
            redirectSignOut: [...REDIRECT_SIGN_OUT],
            responseType: 'code',
            providers: ['Google', 'Facebook'],
          },
        },
      },
    },
  });
}
